import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'digi-select-multiple',
  templateUrl: './select-multiple.component.html',
  styleUrl: './select-multiple.component.scss',
})
export class SelectMultipleComponent {
  @Input() label: string = 'PLACEHOLDER.CHONMUC';
  @Input() options: any[] = [];
  @Input() labelKey: string = 'name';
  @Input() valueKey: string = 'Id';
  @Input() control: FormControl = new FormControl([]);
  @Output() selectionChange = new EventEmitter<any[]>();
  @Input() compareFn = (o1: any, o2: any) => o1 && o2 && o1.Id === o2.Id;
  @Input() errorMessage: string = '';    
  @Input() isSubmit: boolean = false;
  ngOnInit() {
    this.control.valueChanges.subscribe((value) => {
      this.selectionChange.emit(value);
    });
  }
}
